import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { EmployeeEntity } from '../../../domain/entities/employee.entity';

@Injectable({ providedIn: 'root' })
export class GetWatcherOptionsUseCase {
  private readonly _repository = inject(CasesRepository);

  public execute(caseId: string): Observable<EmployeeEntity[]> {
    return this._repository.getWatcherOptions(caseId);
  }
}
